/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardViewQuickFilterDTO } from './LeaderboardViewQuickFilterDTO';
import {
    LeaderboardViewQuickFilterDTOFromJSON,
    LeaderboardViewQuickFilterDTOFromJSONTyped,
    LeaderboardViewQuickFilterDTOToJSON,
} from './LeaderboardViewQuickFilterDTO';
import type { LeaderboardSortParamsDTO } from './LeaderboardSortParamsDTO';
import {
    LeaderboardSortParamsDTOFromJSON,
    LeaderboardSortParamsDTOFromJSONTyped,
    LeaderboardSortParamsDTOToJSON,
} from './LeaderboardSortParamsDTO';
import type { LeaderboardViewColumnListDTO } from './LeaderboardViewColumnListDTO';
import {
    LeaderboardViewColumnListDTOFromJSON,
    LeaderboardViewColumnListDTOFromJSONTyped,
    LeaderboardViewColumnListDTOToJSON,
} from './LeaderboardViewColumnListDTO';
import type { LeaderboardGroupParamsDTO } from './LeaderboardGroupParamsDTO';
import {
    LeaderboardGroupParamsDTOFromJSON,
    LeaderboardGroupParamsDTOFromJSONTyped,
    LeaderboardGroupParamsDTOToJSON,
} from './LeaderboardGroupParamsDTO';

/**
 * 
 * @export
 * @interface LeaderboardViewUpdateDTO
 */
export interface LeaderboardViewUpdateDTO {
    /**
     * 
     * @type {LeaderboardViewColumnListDTO}
     * @memberof LeaderboardViewUpdateDTO
     */
    columnList: LeaderboardViewColumnListDTO;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardViewUpdateDTO
     */
    defaultView: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardViewUpdateDTO
     */
    experimentsOnly?: boolean;
    /**
     * 
     * @type {LeaderboardGroupParamsDTO}
     * @memberof LeaderboardViewUpdateDTO
     */
    groupOptions?: LeaderboardGroupParamsDTO;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardViewUpdateDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardViewUpdateDTO
     */
    nameSearchMode?: LeaderboardViewUpdateDTONameSearchModeEnum;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardViewUpdateDTO
     */
    nameSearchQuery?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardViewUpdateDTO
     */
    query?: string;
    /**
     * 
     * @type {LeaderboardViewQuickFilterDTO}
     * @memberof LeaderboardViewUpdateDTO
     */
    quickFilters?: LeaderboardViewQuickFilterDTO;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardViewUpdateDTO
     */
    runsLineage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardViewUpdateDTO
     */
    showSelectedHiddenByFilter?: boolean;
    /**
     * 
     * @type {LeaderboardSortParamsDTO}
     * @memberof LeaderboardViewUpdateDTO
     */
    sortOptions: LeaderboardSortParamsDTO;
}


/**
 * @export
 */
export const LeaderboardViewUpdateDTONameSearchModeEnum = {
    Substring: 'substring',
    Regexp: 'regexp'
} as const;
export type LeaderboardViewUpdateDTONameSearchModeEnum = typeof LeaderboardViewUpdateDTONameSearchModeEnum[keyof typeof LeaderboardViewUpdateDTONameSearchModeEnum];


/**
 * Check if a given object implements the LeaderboardViewUpdateDTO interface.
 */
export function instanceOfLeaderboardViewUpdateDTO(value: object): value is LeaderboardViewUpdateDTO {
    if (!('columnList' in value) || value['columnList'] === undefined) return false;
    if (!('defaultView' in value) || value['defaultView'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('sortOptions' in value) || value['sortOptions'] === undefined) return false;
    return true;
}

export function LeaderboardViewUpdateDTOFromJSON(json: any): LeaderboardViewUpdateDTO {
    return LeaderboardViewUpdateDTOFromJSONTyped(json, false);
}

export function LeaderboardViewUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardViewUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'columnList': LeaderboardViewColumnListDTOFromJSON(json['columnList']),
        'defaultView': json['defaultView'],
        'experimentsOnly': json['experimentsOnly'] == null ? undefined : json['experimentsOnly'],
        'groupOptions': json['groupOptions'] == null ? undefined : LeaderboardGroupParamsDTOFromJSON(json['groupOptions']),
        'name': json['name'],
        'nameSearchMode': json['nameSearchMode'] == null ? undefined : json['nameSearchMode'],
        'nameSearchQuery': json['nameSearchQuery'] == null ? undefined : json['nameSearchQuery'],
        'query': json['query'] == null ? undefined : json['query'],
        'quickFilters': json['quickFilters'] == null ? undefined : LeaderboardViewQuickFilterDTOFromJSON(json['quickFilters']),
        'runsLineage': json['runsLineage'] == null ? undefined : json['runsLineage'],
        'showSelectedHiddenByFilter': json['showSelectedHiddenByFilter'] == null ? undefined : json['showSelectedHiddenByFilter'],
        'sortOptions': LeaderboardSortParamsDTOFromJSON(json['sortOptions']),
    };
}

export function LeaderboardViewUpdateDTOToJSON(value?: LeaderboardViewUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'columnList': LeaderboardViewColumnListDTOToJSON(value['columnList']),
        'defaultView': value['defaultView'],
        'experimentsOnly': value['experimentsOnly'],
        'groupOptions': LeaderboardGroupParamsDTOToJSON(value['groupOptions']),
        'name': value['name'],
        'nameSearchMode': value['nameSearchMode'],
        'nameSearchQuery': value['nameSearchQuery'],
        'query': value['query'],
        'quickFilters': LeaderboardViewQuickFilterDTOToJSON(value['quickFilters']),
        'runsLineage': value['runsLineage'],
        'showSelectedHiddenByFilter': value['showSelectedHiddenByFilter'],
        'sortOptions': LeaderboardSortParamsDTOToJSON(value['sortOptions']),
    };
}

